/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type GroupUsersListBackofficeTimedUserFragment = {
  __typename?: 'BackofficeTimedUser'
  expires: string | null
  user: {
    __typename?: 'BackofficeUserIdentity'
    firstName: string
    lastName: string
    id: string
    email: string | null
    username: string | null
  }
}

export const GroupUsersListBackofficeTimedUserFragmentDoc = gql`
    fragment GroupUsersListBackofficeTimedUser on BackofficeTimedUser {
  user {
    firstName
    lastName
    id
    email
    username
  }
  expires
}
    `
